import axios from 'axios';

const loadNavigation = ({ api, navigationApiUrl, navigationId }) => {
    const url = navigationApiUrl
        ? `${navigationApiUrl}/v1/navbar/${navigationId}`
        : `${api}/v1/navbars/${navigationId}`;

    return axios.get(url)
        .then(res => (navigationApiUrl ? (res.data && res.data.data) : res.data))
        .catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            return {};
        });
};

export default loadNavigation;
